import { nanoid } from 'nanoid';
import { overlay } from 'overlay-kit';

import {
  openOverlayOnce,
  openOverlayOnceAsync,
} from '@/shared/utils/openOverlayOnce';

type Dialog<T> = (props: T) => JSX.Element;

type Options<T> = Omit<T, 'isOpen' | 'onClose'> & {
  overlayId?: string;
};

export const createDialogManager = <T>(Dialog: Dialog<T>) => {
  return {
    open({ overlayId = nanoid(8), ...options }: Options<T>) {
      return openOverlayOnce(overlayId, ({ unmount }) =>
        Dialog({ ...(options as T), onClose: unmount }),
      );
    },

    async openAsync({
      overlayId = nanoid(8),
      ...options
    }: Options<T>): Promise<boolean> {
      const confirm = (await openOverlayOnceAsync(overlayId, ({ close }) =>
        Dialog({ ...(options as T), onClose: close }),
      )) as boolean;
      overlay.unmount(overlayId);
      return confirm;
    },

    close(overlayId: string) {
      overlay.close(overlayId);
    },

    unmount(overlayId: string) {
      overlay.unmount(overlayId);
    },
  };
};
